module.exports = __webpack_public_path__ + "img/avatar1.c627e797.svg";